import { render } from "./P091.vue?vue&type=template&id=23ee544c&scoped=true"
import script from "./P091.vue?vue&type=script&lang=js"
export * from "./P091.vue?vue&type=script&lang=js"

import "./P091.vue?vue&type=style&index=0&id=23ee544c&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23ee544c"]])

export default __exports__